
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey-thanks",
      function () {
        return require("private-next-pages/survey-thanks/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey-thanks"])
      });
    }
  